export default function getEnv(origin) {
  if (/^https?:\/\/(stage|1)(.*?)\.(gaoding|focodesign)\.com$/.test(origin)) {
    return 'release';
  } else if (/\.(gaoding|focodesign)\.com$/.test(origin) && !/dev.*?\.(gaoding|focodesign)/.test(origin)) {
    return 'production';
  } else if (/\.(gaoding|focodesign)\.localhost$/.test(origin)) {
    return 'localhost';
  } else {
    return 'development';
  }
}